import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";
import Navbar from "../components/Navbar";
import { ReceiptHeader, BankTransferNotice, JerseyGiftCard, OrderSummaryList } from "../components/confirmation/ConfirmationParts";

const lookupError = (e) => (e.response?.status === 429 ? formatApiErrorDetail(e.response.data?.detail) : "Registration not found.");

export default function Confirmation() {
  const { reference } = useParams();
  const [data, setData] = useState(null);
  const [jerseySize, setJerseySize] = useState("");

  const load = useCallback(async () => {
    try { const res = await api.get(`/orders/${reference}`); setData(res.data); setJerseySize(res.data.gift?.jersey_size || ""); }
    catch (e) { toast.error(lookupError(e)); }
  }, [reference]);
  useEffect(() => { load(); }, [load]);

  const saveSize = async () => {
    try { await api.post(`/orders/${reference}/gift-size`, { jersey_size: jerseySize }); toast.success("Jersey size saved!"); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  if (!data) return <div><Navbar /><div className="max-w-xl mx-auto px-4 py-24 text-center text-slate-500">Loading...</div></div>;

  const o = data.order;
  const pending = o.registration_status === "pending_payment" && o.payment_method === "bank";

  return (
    <div><Navbar />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        <div data-testid="confirmation-receipt-card" className="rounded-2xl bg-white border border-[#E2EBF0] shadow-xl overflow-hidden">
          <ReceiptHeader o={o} />
          <div className="p-6 space-y-5">
            {pending && <BankTransferNotice o={o} bank={data.bank_details} />}
            {data.gift && <JerseyGiftCard gift={data.gift} size={jerseySize} setSize={setJerseySize} onSave={saveSize} />}
            <OrderSummaryList o={o} />
            <div className="text-xs text-slate-400 text-center pt-2">Sporting CP Camp Arkansas 2027 &middot; Brunner & Lay Soccer Complex &middot; June 28 – July 2, 2027</div>
          </div>
        </div>
      </div>
    </div>
  );
}
